<template>
  <filter-template @submit="filter()">
    <v-row class="pt-6">
      <v-col cols="12">
        <v-row>
          <v-col cols="12">
            <v-row justify="start">
              <span class="py-4">Data da criação da conciliação:</span>
            </v-row>
          </v-col>
          <v-col
            cols="12"
            class="mt-2"
          >
            <v-row>
              <v-col cols="6">
                <input-date
                  id="input:MinCreatedAt"
                  v-model="payload.MinCreatedAt"
                  label="Data inicial"
                />
              </v-col>
              <v-col cols="6">
                <input-date
                  id="input:MaxCreatedAt"
                  v-model="payload.MaxCreatedAt"
                  label="Data final"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row class="mt-6">
          <v-col cols="12">
            <v-row justify="start">
              <span class="py-4">Data da conciliação:</span>
            </v-row>
          </v-col>
          <v-col
            cols="12"
            class="mt-2"
          >
            <v-row>
              <v-col cols="6">
                <input-date
                  id="input:MinUpdatedAt"
                  v-model="payload.MinUpdatedAt"
                  label="Data inicial"
                />
              </v-col>
              <v-col cols="6">
                <input-date
                  id="input:MaxUpdatedAt"
                  v-model="payload.MaxUpdatedAt"
                  label="Data final"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row class="mt-8">
          <input-select
            id="input:Status"
            v-model="payload.Status"
            label="Status"
            :items="statusOptions"
            clearable
          />
        </v-row>
        <v-row>
          <input-select
            id="input:Interval"
            v-model="payload.Interval"
            label="Intervalo"
            :items="intervalOptions"
            clearable
          />
        </v-row>
      </v-col>
    </v-row>
  </filter-template>
</template>

<script>
import FilterTemplate from '@/app/arch/components/crud/components/FilterTemplate.vue';
import FilterMixin from '@/app/arch/components/crud/crud-mixins/FilterMixin';
import InvoiceConciliationStatus from 'Modules/contacard/conciliations/invoice/components/InvoiceConciliationStatus';
import InvoiceConciliationInterval from 'Modules/contacard/conciliations/invoice/components/InvoiceConciliationInterval';
import FilterDateMixin from 'Arch/mixins/FilterDateMixin';

export default {
  name: 'InvoiceConciliationFilter',
  components: { FilterTemplate },
  mixins: [FilterMixin, FilterDateMixin],
  data: () => ({
    payload: {
      Interval: '',
      Status: '',
      MinCreatedAt: '',
      MaxCreatedAt: '',
      MinUpdatedAt: '',
      MaxUpdatedAt: '',
    },
    statusOptions: InvoiceConciliationStatus,
    intervalOptions: InvoiceConciliationInterval,
  }),
  watch: {
    'payload.Interval': {
      handler(value) {
        if (value) {
          this.handleDateByInterval(value);
        }
      },
    },
  },
  created() {
    this.setInitialDate();
  },
};
</script>

<style>

</style>
